export default __webpack_public_path__ + "static/media/user2.418e2f62.svg";